import Highlight from "@tiptap/extension-highlight";

const HighlightExtension = Highlight.extend({
  addAttributes() {
    return {
      color: {
        default: null,
        parseHTML: (element: HTMLElement) => element.style.backgroundColor || null,
        renderHTML: (attributes: Record<string, string>) => {
          if (!attributes.color) return {};
          return { style: `background-color: ${attributes.color}` };
        },
      },
    };
  },
});

export default HighlightExtension.configure({ multicolor: true });
